module.exports = __webpack_public_path__ + "static/media/webcam-slash.31ce493a.svg";